const GSM7_BASIC = new Set(
  Array.from(
    '@£$¥èéùìòÇ\nØø\rÅåΔ_ΦΓΛΩΠΨΣΘΞ\u001b ÆæßÉ !"#¤%&\'()*+,-./0123456789:;<=>?' +
      '¡ABCDEFGHIJKLMNOPQRSTUVWXYZÄÖÑÜ§¿abcdefghijklmnopqrstuvwxyzäöñüà',
  ),
);
const GSM7_EXTENSION = new Set(Array.from('\f^{}\\[~]|€'));

export const gsm7 = (text: string | null | undefined): boolean =>
  Array.from(text ?? '').every(
    (c) => GSM7_BASIC.has(c) || GSM7_EXTENSION.has(c),
  );

// UCS-2 counts UTF-16 units, so an emoji outside the Basic Multilingual Plane
// is two, as graphy's SmsText.length and Twilio count it. Counting code points
// showed one segment fewer than the server lint that refuses the publish
// (bug hunt 17).
export const smsLength = (text: string | null | undefined): number => {
  const chars = Array.from(text ?? '');
  if (!gsm7(text)) return (text ?? '').length;
  return chars.reduce((sum, c) => sum + (GSM7_EXTENSION.has(c) ? 2 : 1), 0);
};

export const smsSegments = (text: string | null | undefined): number => {
  const value = text ?? '';
  if (value === '') return 0;
  const length = smsLength(value);
  if (gsm7(value)) return length <= 160 ? 1 : Math.ceil(length / 153);
  return length <= 70 ? 1 : Math.ceil(length / 67);
};
